import { NgModule } from '@angular/core';
import { NotificationComponent } from '../../domain/shared/component/notification/notification.component';
import { LayoutComponent } from '../component/layout/layout.component';
import { SideNavComponent } from '../component/sidenav/side-nav.component';
import { HorizontalNavBarComponent } from '../component/hornavbar/horizontal-nav-bar.component';
import {
  HorNavBarCompanySearchComponent,
} from '../component/hornavbar/hornavbar-company-search/hor-nav-bar-company-search.component';
import { SharedComponentsModule } from '../../domain/shared/module/shared-components.module';
import { FundPerformanceSharedModule } from '../../domain/fund-performance/module/fund-performance-shared.module';
import { ModalStayComponent } from '../component/modal-stay/modal-stay.component';
import { RemindersModule } from '../../domain/reminders/module/reminders.module';
import {
  GlobalCompanySearchComponent,
} from '../../domain/company/component/global-company-search/global-company-search.component';
import { NumberswitcherComponent } from '../component/numberswitcher/numberswitcher.component';
import { UnsavedChangesModalWrapperComponent }
  from 'src/app/domain/shared/component/unsaved-changes-modal-wrapper/unsaved-changes-modal-wrapper.component';
import { OrgPickerComponent } from '../component/hornavbar/org-picker/org-picker.component';
import { PeriodPickerComponent } from '../component/hornavbar/period-picker/period-picker.component';
import { NavAvatarComponent } from "../../domain/profile/component/avatar/nav-avatar.component";
import { AiButtonComponent } from '../../domain/shared/component/buttons/ai-button/ai-button.component';
import { GlobalAiChatModalComponent } from '../../domain/global-ai/modal/global-ai-chat-modal/global-ai-chat-modal.component';
import { ModalExpiredSessionComponent } from "../component/modal-expired-session/modal-expired-session.component";

@NgModule({
  declarations: [
    HorizontalNavBarComponent,
    HorNavBarCompanySearchComponent,
    LayoutComponent,
    NotificationComponent,
    SideNavComponent,
    ModalStayComponent,
    NumberswitcherComponent,
    UnsavedChangesModalWrapperComponent,
  ],

  imports: [
    SharedComponentsModule,
    FundPerformanceSharedModule,
    NavAvatarComponent,
    RemindersModule,
    GlobalCompanySearchComponent,
    OrgPickerComponent,
    PeriodPickerComponent,
    AiButtonComponent,
    GlobalAiChatModalComponent,
    ModalExpiredSessionComponent,
  ],

  providers: [],

  exports: [
    HorizontalNavBarComponent,
    HorNavBarCompanySearchComponent,
    LayoutComponent,
    NotificationComponent,
    SideNavComponent,
    NumberswitcherComponent,
    UnsavedChangesModalWrapperComponent,
  ],
})
export class CoreModule {}
